module.exports = __webpack_public_path__ + "img/plat_4872.9150ea62.jpg";